import { i18n } from "@dehub/theme";
import type { AlertTrigger } from "../../apis/return-prevention-alert";

export function triggerLabel (type?: AlertTrigger | string | null): string {
  if (!type) return "";
  return i18n.t(`returns:triggerType.${type}`, { defaultValue: type });
}
